import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AuthShell, { inputCls } from "@/components/site/AuthShell";
import { useAuth } from "@/components/site/auth";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(form.email, form.password);
      nav(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (e2) { setErr(formatApiError(e2)); } finally { setLoading(false); }
  };

  return (
    <AuthShell testid="login-page" title="Welcome" highlight="back" sub="Sign in to your Ilmora account">
      <form onSubmit={submit} className="space-y-3">
        <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} data-testid="login-email-input" />
        <input required type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={inputCls} data-testid="login-password-input" />
        {err && <p data-testid="login-error" className="text-sm text-red-500">{err}</p>}
        <button disabled={loading} data-testid="login-submit-btn" className="btn-neon w-full justify-center disabled:opacity-70">{loading && <Loader2 className="animate-spin" size={18} />} Sign In</button>
      </form>
      <p className="text-sm text-center mt-6 text-[var(--muted)]">New here? <Link to="/register" data-testid="go-register-link" className="text-[var(--pink)] font-semibold">Create your ID</Link></p>
    </AuthShell>
  );
}
